module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/conscientiousness/b6c23e089a93ccc09f8aaed46cecf397.png";